import {Dispatch, GetState} from '../app-types';
import {AbortCategory, postJsonWithBody} from './fetcher';
import {showError} from '../message-box/message-box-actions';
import {fetchDocumentDetails} from '../search/duck/search-actions';
import {ProdDocument, TagUpdate} from '../search/search-types';
import {SearchPageType} from '../search/search-config';
import DetailedError from './DetailedError';

export const upsertTag = (
    searchPageType: SearchPageType,
    doc: ProdDocument,
    updatedTagValue: TagUpdate,
): ((dispatch: Dispatch, getState: GetState) => void) => {
    return updateTag(searchPageType, doc, updatedTagValue, '/upsertTags');
};

export const deleteTag = (
    searchPageType: SearchPageType,
    doc: ProdDocument,
    updatedTagValue: TagUpdate,
): ((dispatch: Dispatch, getState: GetState) => void) => {
    return updateTag(searchPageType, doc, updatedTagValue, '/deleteTags');
};

export const updateTag = (
    searchPageType: SearchPageType,
    doc: ProdDocument,
    updatedTagValue: TagUpdate,
    endpoint: string,
): ((dispatch: Dispatch, getState: GetState) => void) => {
    return (dispatch: Dispatch, getState: GetState): void => {
        const request = {
            containerName: getState().settings.containerName,
            documentId: doc.id,
            updatedTagValue: updatedTagValue,
        };
        postJsonWithBody<any>(endpoint, JSON.stringify(request), AbortCategory.UPDATE)
            .then(() => {
                dispatch(fetchDocumentDetails(doc));
            })
            .catch((error: DetailedError) => {
                console.error('Document could not be updated. Error type {} and error message {}', error.detail.errorType, error.detail.errorMessage);
                return dispatch(showError(searchPageType, 'Document could not be updated!'));
            });
    };
};
